import { IOptions } from '../../../common/common.types'
import { filterEkgComments } from '../../../utilities/ekgImport.util'
import { initialSedationScaleState } from '../../vitals/store/vitals.reducers'
import { IPatientVitals, ITempMethodOptions } from '../../vitals/store/vitals.types'
import { IEventVitals } from '../store/ekgImport.types'

export const createPatientVitals = (
  eventVitals: IEventVitals,
  isPTA: boolean,
  bloodPressureMethodOptions: IOptions,
  temperatureMethodOptions: ITempMethodOptions,
  heartRateMethodOptions: IOptions,
  etco2TypeOptions: IOptions
): IPatientVitals => {
  const bloodPressureMethodOption = bloodPressureMethodOptions.find((option) => {
    return option.id === Number(eventVitals.bloodPressureMethod)
  })
  const temperatureMethodOption = temperatureMethodOptions.find((option) => {
    return option.id === Number(eventVitals.temperatureMethod)
  })

  let heartRateMethodOption = null
  let etco2TypeOption = null

  if (eventVitals.heartRate !== '' && eventVitals.heartRate !== null && eventVitals.heartRate !== undefined) {
    heartRateMethodOption =
      heartRateMethodOptions.find((option) => {
        return option.id === 3
      }) || null
  }

  if (eventVitals.etCO2 !== '' && eventVitals.etCO2 !== null && eventVitals.etCO2 !== undefined) {
    etco2TypeOption =
      etco2TypeOptions.find((option) => {
        return option.id === 1
      }) || null
  }
  const { comments } = eventVitals
  const filteredComments = filterEkgComments(comments)
  const clientCorrelationId = `patient.patientVitals_${eventVitals.key}`
  const patientVitals: IPatientVitals = {
    ...eventVitals,
    clientCorrelationId,
    comments: filteredComments,
    pta: isPTA,
    assessedBy: null,
    bloodPressureMethod: bloodPressureMethodOption || null,
    heartRateMethod: heartRateMethodOption,
    roomAir: false,
    respirationRateEffort: null,
    rhythm: [],
    regularity: null,
    ecgType: null,
    ecgTypeMethod: [],
    ecgTypeMethodPNNV: null,
    temperature: eventVitals.temperature || null,
    temperatureType: eventVitals.temperatureType || '',
    temperatureMethod: temperatureMethodOption || null,
    spCO: eventVitals.spCO,
    spMet: eventVitals.spMet,
    rts: null,
    etCO2: eventVitals.etCO2 || null,
    etCO2Type: etco2TypeOption,
    glucose: null,
    glucoseLevel: 'Low',
    levelOfConsciousness: null,
    pain: '',
    strokeScale: null,
    strokeScalePNNV: null,
    strokeScoreFlag: false,
    strokeScaleScoreTotal: null,
    eyeOpeningResponse: null,
    verbalResponse: null,
    motorResponse: null,
    protocol: null,
    totalGCSScore: null,
    eyeOpeningResponseScore: 0,
    verbalResponseScore: 0,
    motorResponseScore: 0,
    nihPositiveStrokeScaleScoreMap: new Map(),
    raceStrokeScaleScoreMap: new Map(),
    showRepeatVitals: true,
    reRunValidations: false,
    showDateTimeToast: false,
    showPTAToast: false,
    __isPainRangeActivated: false,
    painType: null,
    painScales: {
      totalsCombined: '',
      painScaleSelections: [],
    },
    diastolicBPPNNV: null,
    systolicBPPNNV: null,
    bloodPressureMethodPNNV: null,
    heartRatePNNV: null,
    spo2PNNV: null,
    respirationRatePNNV: null,
    rhythmPNNV: null,
    temperaturePNNV: null,
    spCOPNNV: null,
    etCO2PNNV: null,
    glucosePNNV: null,
    painPNNV: null,
    eyeOpeningResponsePNNV: null,
    verbalResponsePNNV: null,
    motorResponsePNNV: null,
    totalGCSScorePNNV: null,
    gcsQualifier: [],
    gcsQualifierPNNV: null,
    apgarAppearance: null,
    apgarPulse: null,
    apgarGrimace: null,
    apgarActivity: null,
    apgarRespiration: null,
    totalApgarScore: null,
    totalApgarScorePNNV: null,
    __manualApgarTotalChecked: false,
    apgar: null,
    __isRedirectedFrom: null,
    customVitalLabel1: '',
    customVitalLabel2: '',
    customVitalValue1: '',
    customVitalValue2: '',
    customVitalConfig: null,
    __customVitalLabelExists: false,
    vitalsStrokeScaleValues: [],
    strokeScaleScoreTotalPNNV: null,
    __isStrokeScaleScoreTotalPNNVEnabled: false,
    painQuality: null,
    shockIndex: '',
    sedationScale: { ...initialSedationScaleState },
    withdrawalScaleCriteria: [],
    withdrawalScaleType: null,
    withdrawalScaleTotal: null,
    withdrawalScaleTotalPNNV: null,
    __isWithdrawalScaleTotalPNNVEnabled: false,
    __isWithdrawalScaleTypeCleared: false,
  }

  return patientVitals
}
